import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCurrentUser = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}auth/tenant/me`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getCurrentUser